<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="videoRecipe?.title" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container *ngIf="videoRecipe">
        <div class="modal-body" style="height: auto;" [ngClass]="isIOS() === true ? 'ios' : ''">
            <iframe
                    frameborder="0"
                    allow="autoplay"
                    [src]="sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + youtubeParser(videoRecipe.youtube_link) + '?autoplay=1')"
                    width="100%"
                    height="360"></iframe>
        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        </div>
    </ng-container>
</div>
